/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class AuthenticationController {
   $log: any
   $scope: any
   $window: any
   authentication: any
   doRefreshToken: any
   formatUrl: any
   i18n: any
   logoutEverywhere: any
   logoutEverywhereUrl: any
   openPopupWindow: any
   translationService: any
   constructor($scope: any, authentication: any, config: any, translationService: any, $log: any, $window: any) {
      this.login = this.login.bind(this)
      this.logInOut = this.logInOut.bind(this)
      this.logout = this.logout.bind(this)
      this.openLoginDialog = this.openLoginDialog.bind(this)
      this.openLogoutDialog = this.openLogoutDialog.bind(this)
      this.cancel = this.cancel.bind(this)
      this.$scope = $scope
      this.authentication = authentication
      this.translationService = translationService
      this.$log = $log
      this.$window = $window
      this.$scope.authScope = this.authentication.scope
      this.$scope.auth = this.authentication.scope.auth
      this.formatUrl = this.authentication.formatUrl
      this.i18n = this.translationService
      this.doRefreshToken = this.authentication.doRefreshToken
      this.logoutEverywhere = false
      this.openPopupWindow = this.authentication.openPopupWindow
      this.$scope.providers = this.$scope.$resolve.providers
   }

   login(feature: any, provider: any, redirectUrl: any) {
      return this.authentication.login(feature, provider, redirectUrl)
   }

   logInOut(feature: any, provider: any, redirectUrl: any, summonOnly: any) {
      if (this.$scope.auth[provider].loggedIn) {
         return this.logout(feature, provider, redirectUrl, summonOnly)
      } else {
         return this.login(feature, provider, redirectUrl)
      }
   }

   logout(feature: any, provider: any, redirectUrl: any, summonOnly: any) {
      const logoutPromise = this.authentication.logout(feature, provider, redirectUrl, summonOnly)
      if (!summonOnly) {
         this.logoutEverywhere = true
         return logoutPromise
            .then((response: any) => { 
               if (response.data.logout_url === false) {
                  // we just pretend we're logged out everywhere - there is no logout_url
                  this.logoutEverywhere = false
                  this.cancel()
               } else { 
                  this.logoutEverywhereUrl = response.data.logout_url
               }
            }).catch((response: any) => {
               // just cancel, the toast should show what happened
               this.cancel()
            })
      }
   }

   // this starts the login flow, and in here we can choose which provider
   openLoginDialog(feature: any, redirectUrl = this.$window.location.href) {
      return this.authentication.openLoginDialog(feature, redirectUrl)
   }

   openLogoutDialog(feature: any, provider: any, redirectUrl = this.$window.location.href) {
      return this.authentication.openLogoutDialog(feature, provider, redirectUrl)
   }

   cancel() {
      this.authentication.closeLoginDialog()
      this.authentication.closeLogoutDialog()
      return this.logoutEverywhere = false
   }
}

AuthenticationController.$inject = ['$scope', 'authenticationService', 'configService', 'translationService', '$log', '$window']

angular.module('summonApp.controllers')
   .controller('authenticationController', AuthenticationController)
